import React from 'react'

type Status = 'error' | 'success' | 'loading' | 'stale'

export function useStatus(initialStatus: Status = 'stale') {
    const [status, setStatus] = React.useState(initialStatus)

    const load = () => setStatus('loading')
    const done = () => setStatus('success')
    const stop = () => setStatus('error')
    const reset = () => setStatus('stale')

    const isLoading = status === 'loading'
    const isSuccess = status === 'success'
    const isError = status === 'error'

    return {status, isLoading, isError, isSuccess, load, done, stop, reset }
}
